export default {
    canned_commands_tab_title: "Canned Commands",
    canned_commands_tab_label: "Label",
    canned_commands_tab_command: "Command",
    canned_commands_tab_via: "Via",
    canned_commands_tab_status: "Status",
    canned_commands_tab_unit_type: "Unit Type",
    canned_commands_tab_created_on: "Created on",
    canned_commands_tab_created_by: "Created By",
    canned_commands_tab_updated_on: "Updated On",
    canned_commands_tab_updated_by: "Updated By",
    canned_commands_tab_add_new: "Add New",
    canned_commands_tab_apply_to_all: "Apply to All Types"
    
}